import { render, staticRenderFns } from "./BoxRentalAndPre_Sale.vue?vue&type=template&id=96b17762&scoped=true&"
import script from "./BoxRentalAndPre_Sale.vue?vue&type=script&lang=js&"
export * from "./BoxRentalAndPre_Sale.vue?vue&type=script&lang=js&"
import style0 from "./BoxRentalAndPre_Sale.vue?vue&type=style&index=0&id=96b17762&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b17762",
  null
  
)

export default component.exports